<template>
<div>
  <div class="card intro" >
      <!-- <div class="card intro" v-if="metadata.external_url && metadata.intro"> -->
      <h3 class="title is-size-4 is-size-5-mobile" style="margin-bottom:5px; text-align:center">About {{($noThe(metadata.display_name) ? '' : 'The ')}} {{metadata.display_name}}</h3>
      <div class="spacer" style="height:30px"></div>
      <div v-if="metadata.intro">
            
            <div class="is-size-6 is-size-7-mobile"  v-html="metadata.intro"></div><br>
            <!-- <div>Learn more: <a class="is-size-6 is-size-7-mobile" v-if="metadata.intro" :href="metadata.external_url" target="_blank">{{metadata.display_name}}</a></div> -->

            <div class="spacer" style="height:10px"></div>
      </div>
        <div class="columns">

            <div class="column">
                <div class="columns is-variable is-mobile">
                    <div class="column" v-if="metadata.length">
                        <span class="small-label" style="margin-bottom:5px">Length</span>
                        <p class="is-size-6 is-size-7-mobile">{{metadata.length}}</p>
                    </div>
                    <div class="column" v-if="metadata.continent">
                        <span class="small-label" style="margin-bottom:5px">Continent</span>
                        <p class="is-size-6 is-size-7-mobile">{{metadata.continent}}</p>
                    </div>
                </div>
            </div>

            <div class="column">
                <div class="columns is-variable is-mobile">
                    <div class="column" v-if="metadata.countries && Array.isArray(metadata.countries)">
                        <span class="small-label" style="margin-bottom:5px">Countries</span>
                        <p class="is-size-6 is-size-7-mobile">{{getDisplayCountries(metadata.countries).slice(0,5).join(", ")}}
                            <span v-if="metadata.countries.length > 5"> and more</span>
                        </p>
                    </div>
                    <div class="column" v-if="metadata.us_states && Array.isArray(metadata.us_states)">
                        <span class="small-label" style="margin-bottom:5px">States</span>
                        <p class="is-size-6 is-size-7-mobile">{{metadata.us_states.slice(0,5).join(", ")}}
                            <span v-if="metadata.us_states.length > 5"> and more</span></p>
                    </div>
                </div>
            </div>

        </div>
        
        <!-- <div class="spacer" style="height:10px"></div> -->

        <div class="columns">

            <div class="column" v-if="metadata.bikepacking || metadata.touring || metadata.gravel || metadata.road 
                || metadata.singletrack || metadata.race || metadata.railtrail || metadata.bikepath">
                <span class="small-label" style="margin-bottom:5px">Styles</span>
                <div>
                    <b-tag v-if="metadata.touring" class="tag is-light" >touring</b-tag>
                    <b-tag v-if="metadata.bikepacking" class="tag is-light" >bikepacking</b-tag>
                    <b-tag v-if="metadata.racing" class="tag is-light" >racing</b-tag>
                    <b-tag v-if="metadata.road" class="tag is-light" >road</b-tag>
                    <b-tag v-if="metadata.gravel" class="tag is-light" >gravel</b-tag>
                    <b-tag v-if="metadata.singletrack" class="tag is-light" >singletrack</b-tag>
                    <b-tag v-if="metadata.railtrail" class="tag is-light" >rail trail</b-tag>
                    <b-tag v-if="metadata.bikepath" class="tag is-light" >bike path</b-tag>
                </div>
            </div>

            <div class="column" v-if="metadata.external_url || metadata.external_link">
                <span class="small-label" style="margin-bottom:5px">Learn More</span>
                <a class="is-size-6 is-size-7-mobile" v-if="metadata.external_url" :href="metadata.external_url" target="_blank">{{metadata.display_name}} 
                    <span class="is-size-6 is-size-7-mobile">{{ getExternalSiteName(metadata.external_url)}}</span></a>
                <a class="is-size-6 is-size-7-mobile" v-if="metadata.external_link" :href="metadata.external_link" target="_blank">{{metadata.display_name}} 
                    <span class="is-size-6 is-size-7-mobile">{{getExternalSiteName(metadata.external_link)}}</span></a>
                
            </div>

        </div>


       
    
    

    </div>
  <div class="spacer" style="height:40px"></div>
  </div>
</template>

<script>
export default {
  name: 'Intro',
  props: ['metadata'],
  data () {
    return {
    }
  },
  methods: {
      getDisplayCountries(codesArray) {
          var namesArray = [];
          for (const code in codesArray) {
              namesArray.push(this.$countrymap[codesArray[code]]);
          }
          return namesArray;
      },
      getExternalSiteName(url) {
          if (url.includes('bikepacking.com')) {
              return '(bikepacking.com)';
          } else if (url.includes("adventurecycling.org")) {
              return "(Adventure Cycling)";
          } else if (url.includes('bikepackingroots.org')) {
              return "(Bikepacking Roots)"
          }
          else return "";
      }
  },
  metaInfo() {
        return {
           
            
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .intro {
        padding:50px;
        text-align:left;
    }
    @media screen and (max-width: 768px) {
        .intro {
            padding:20px;
            text-align:left;
        }
    }
</style>





// WEBPACK FOOTER //
// src/components/Intro.vue